import * as React from 'react'

import FormText, { FormStyles } from 'embed/components/FormText'
import { Mask } from 'embed/constants'
import { LoanAmountValidator } from 'common/services/Validation'
import { Filter } from 'even-ts-static'

export interface Props {
  containerClass?: string
  onChange?: (fieldName: string, value: string, isValid: boolean) => void
  placeholder?: string
  styles: FormStyles
  startingValue?: number
}

export const LoanAmount: React.FC<Props> = ({
  containerClass,
  onChange,
  placeholder = 'Enter an amount',
  startingValue,
  styles,
}) => {
  const onChangeHandler = React.useCallback(
    (fieldName, value, isValid) => onChange?.(fieldName, value.replace(/\D/g, ''), isValid),
    [onChange],
  )

  return (
    <FormText
      containerClass={containerClass}
      fieldName={Filter.LoanAmount}
      inputmode="numeric"
      label="Amount"
      mask={Mask.Currency}
      onChange={onChangeHandler}
      placeholder={placeholder}
      value={startingValue ? startingValue.toString() : undefined}
      showValidationAsYouType={true}
      styles={styles}
      validate={new LoanAmountValidator().isValid}
    />
  )
}
